import AddAppointment from "components/appointment/AddAppointment";
import CheckInButton from "components/common/CheckInButton";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Navbar } from "reactstrap";
import { appointmentsSelector } from "slices/appointmentSlice";
import { closeAppointmentPopup, setAddAppointmentPopup } from "slices/appointmentSlice";
import { fetchMainAccountDashboardAnalytics, fetchMainAccountDashboardAppointments } from "slices/mainAccount/dashboardSlice";
import Api from "services/api";

let userSlice;
function Header(props) {
  const [color] = React.useState("transparent");
  const { user } = useSelector((state) => state.user);
  const [dropdownOpen, setDropdownOpen] = React.useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { popup: appointmentPopUpState } = useSelector(appointmentsSelector);

  const refDropdown = React.useRef(null);

  useEffect(() => {
    userSlice = require("../../slices/userSlice");
  }, []);

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (refDropdown.current && !refDropdown.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Close dropdown on route change
  useEffect(() => {
    setDropdownOpen(false);
  }, [location]);

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const handleClose = () => dispatch(closeAppointmentPopup());

  const callback = () => {
    handleClose();
    appointmentPopUpState?.callback && appointmentPopUpState?.callback();
    dispatch(fetchMainAccountDashboardAnalytics());
    dispatch(fetchMainAccountDashboardAppointments());
  };

  const handleCreateRequestClick = async () => {
    const normalizedUser = user?.user ?? user;
    const defaultAccountLabel = normalizedUser?.name
      || normalizedUser?.company_name
      || normalizedUser?.full_name
      || normalizedUser?.email;

    dispatch(setAddAppointmentPopup({
      show: true,
      item: {
        account_name: defaultAccountLabel,
      },
      popupType: "client-portal",
      callback: callback,
    }));

    try {
      const response = await Api.clientAccountId(normalizedUser?.id);
      const subClient = response?.data?.data || [];
      const defaultAccountId = subClient[0]?.id;

      dispatch(setAddAppointmentPopup({
        show: true,
        item: {
          account_id: defaultAccountId,
          account_name: defaultAccountLabel,
          sub_accounts: subClient[0]?.sub_accounts || [],
        },
        popupType: "client-portal",
        callback: callback,
      }));
    } catch (error) {
      console.error("Failed to load client account for portal request", error);
    }
  };

  const handleLogout = () => {
    dispatch(userSlice.logout());
    navigate("/login", { replace: true });
  };

  return (
    <>
      <AddAppointment
        item={appointmentPopUpState.item}
        show={appointmentPopUpState.show}
        onClose={handleClose}
        callback={callback}
        popupType={appointmentPopUpState.popupType}
      />
      <Navbar
        expand="lg"
        className={
          location.pathname.indexOf("full-screen-maps") !== -1
            ? "navbar-absolute border-0 fixed-top"
            : "navbar-absolute border-0 fixed-top " +
              (color === "transparent" ? "navbar-transparent " : "")
        }
      >
        <div className="header">
          <button className="toggle_sidebar" onClick={props.toggleSidebar}>
            <img src="/images/ham.png" alt="" />
          </button>

          <div className="row_user_side">
            {/* <button className="main_button" onClick={handleCreateRequestClick} type="button">
              Create Request
            </button> */}
            {/* <CheckInButton
                initialCheckedIn={user?.checkin === 1}
                role={user?.role}
                internalInterpreter={user?.user?.internal_interpreter}
            /> */}
            <div ref={refDropdown} className="d-flex align-items-center gap-2 position-relative">
              <button className="user_image" onClick={toggleDropdown}>
                <img src="/images/default-person.png" alt="" />
                <span></span>
              </button>

              <button
                className={`drop_icon ${dropdownOpen ? "active" : ""}`}
                onClick={toggleDropdown}
              >
                <img src="/images/drop.png" alt="" />
              </button>

              <div
                className={`drop_more_selector ${
                  dropdownOpen ? "active" : ""
                }`}
              >
                <ul>
                  <li>
                    <Link to="/user/profile">Profile</Link>
                  </li>
                  <li>
                    <Link to="/user/change-password">Change Password</Link>
                  </li>
                  <li>
                    <Link href="#!">Help</Link>
                  </li>
                  <li>
                    <a
                      href=""
                      onClick={handleLogout}
                      className="red_clr"
                    >
                      Log Out
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </Navbar>
    </>
  );
}

export default Header;
